<template>
  <b-card
    class="unban-preview"
  >
    <player-unban-link
      :playerId="playerId"
      :unbanId="object.id"
    />

    <table>
      <tr>
        <th>Unbanner</th>
        <td>
          <user-link
            :user="getUser(object.userId)"
          />
        </td>
      </tr>
      <tr>
        <th>Time</th>
        <td>{{object.ctime | getMomentMinStr}}</td>
      </tr>
      <tr class="util-tr">
        <th>Planned duration</th>
        <td></td>
      </tr>
    </table>

  </b-card>
</template>

<script>
import { getUserFromMap } from '../model/user';

import PlayerUnbanLink from './PlayerUnbanLink.vue';
import UserLink from './UserLink.vue';

export default {
  name: 'PlayerUnbanPreview',

  components: {
    PlayerUnbanLink,
    UserLink,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    },

    object: {
      type: Object,
      required: true,
    },

    userMap: {
      type: Map,
      required: true,
    },
  },

  methods: {
    getUser(userId) {
      return getUserFromMap(this.userMap, userId);
    },
  },
};
</script>

<style scoped>
.unban-preview .card-body {
  padding: 8px;
}

.unban-preview th {
    padding-right: .5rem;
}

.util-tr {
  line-height: 0;
  overflow: hidden;
  visibility: hidden;
}
</style>
